import React, { useEffect } from "react";
import axios from "axios";

import URL from "../../common/variables";
import { isActiveToken, axiosHeadersConfig } from "./../../common/functions";

const Bookmarks = () => {
  const nodes = document.querySelectorAll(".lajornada__bookmark");
  const isLogged = isActiveToken();

  useEffect(() => {
    // Create eventListeners
    nodes.forEach((e) => eventListener(e));

    if (isLogged) {
      const config = axiosHeadersConfig();

      getUserBookmarks(config);
    }
  }, []);

  const eventListener = (element) => {
    element.addEventListener("click", handleClick, false);
  };

  const handleClick = (event) => {
    event.preventDefault();

    const {
      category,
      date,
      first_image,
      pk,
      title,
      username,
      slug,
    } = event.target.dataset;
    const data = { title, category, first_image, date, slug, user: pk };

    if (isLogged) {
      const config = axiosHeadersConfig();

      axios
        .post(`${URL}/bookmarks/${username}/`, data, config)
        .then(() => alert("Nota guardada"))
        .catch((err) => console.error(err.response));
    } else {
      window.location.href = "/pages/perfil/";
    }

    return false;
  };

  const getUserBookmarks = (config) => {
    axios
      .get(`${URL}/rest-auth/user/`, config)
      .then((response) =>
        nodes.forEach((e) => {
          e.childNodes[1].dataset.pk = response.data.pk;
          e.childNodes[1].dataset.username = response.data.username;
        })
      )
      .catch((err) => console.error(err.response));
  };

  return null;
};

export default Bookmarks;
